export const MESSAGE_COURSE_END = -200
